import api from 'shared/api';
import get from 'lodash.get';
import { formatOrderBy } from 'shared/helpers';
import * as types from '../redux/account/actionTypes';

export const fetchCustomerAccounts = () => async (dispatch) => {
  dispatch({ type: types.FETCH_CUSTOMER_ACCOUNTS_REQUEST });
  try {
    const response = await api.get('/api/v1/customer-accounts/');
    dispatch({
      type: types.FETCH_CUSTOMER_ACCOUNTS_SUCCESS,
      payload: get(response, 'data.results', []),
    });
  } catch (error) {
    dispatch({
      type: types.FETCH_CUSTOMER_ACCOUNTS_FAILURE,
      payload: get(error, 'message'),
    });
  }
};

export const getCustomerAccount = (accountId) => {
  const url = `/api/v1/customer-accounts/${accountId}/`;
  return api.get(url);
};

// Filtered lists by customer account
export const fetchAccountOrders = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/orders/?customer__account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountLicenses = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/licenses/?customer__account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountLicenseUserGroups = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/license-user-groups/?customer_account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountLicenseUsers = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/users/?license__order__customer_account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountDevices = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/devices/?license__order__customer_account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountCustomers = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  return api.get(
    `/api/v1/customers/?customer_account=${accountId}${limitQuery}${offsetQuery}${orderQuery}`,
  );
};

export const fetchAccountManagers = (accountId, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  const query = `${limitQuery}${offsetQuery}${orderQuery}`;
  return api.get(
    `/api/v1/customer-accounts/${accountId}/managers/${
      query ? `?${query.slice(1)}` : ''
    }`,
  );
};

export const addAccountManager = (accountId, data) => {
  const url = `/api/v1/customer-accounts/${accountId}/add_manager/`;
  return api.post(url, data);
};

export const removeAccountManager = (accountId, licenseUserId) => {
  const url = `/api/v1/customer-accounts/${accountId}/remove_manager/`;
  return api.post(url, { license_user_id: licenseUserId });
};

export const addAccountOrders = (accountId, orderIds) => {
  const url = `/api/v1/customer-accounts/${accountId}/add_orders`;
  return api.post(url, { order_ids: orderIds });
};

export const removeAccountOrders = (orderIds) => {
  const url = `/api/v1/customer-accounts/remove_orders`;
  return api.post(url, { order_ids: orderIds });
};

export const updateCustomerAccount = (accountId, data) => async (dispatch) => {
  dispatch({ type: types.UPDATE_CUSTOMER_ACCOUNT_REQUEST });
  try {
    const response = await api.patch(
      `/api/v1/customer-accounts/${accountId}/`,
      data,
    );
    dispatch({
      type: types.UPDATE_CUSTOMER_ACCOUNT_SUCCESS,
      payload: get(response, 'data'),
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: types.UPDATE_CUSTOMER_ACCOUNT_FAILURE,
      payload: get(error, 'message'),
    });
    throw error;
  }
};
